import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useApi } from '../../context/ApiProvider';
import Card from '../Helpers/Card';
import { useLocale } from "../../localization/LocaleProvider";

export default function Dashboard() {
  const [clients, setClients] = useState([]);
  const { translate } = useLocale();
  const Api = useApi();

  useEffect(() => {
    Api.get("/clients").then(data => {
      setClients(data);
    });
  }, [])

  return (
    <div className="grid-container">
      <section>
        <h2>{translate("Rolf Administration")}</h2>
        <p>
          {translate("Welcome to the Rolf Administration interface.")}
        </p>
        <p>
          {translate("Here you can manage your clients, organisations, members and administrators.")}
        </p>

        <h3>{translate("Clients you represent")}</h3>
        <section className="flex wrap">
          {clients && clients.map(function (client, index) {
            const href = '' + client.ID
            return (
              <Card key={index} className="small">
                <Link to={`/clients/${client.ID}`}>{client.name}</Link>
              </Card>)
          })}
        </section>
      </section>
    </div>
  )
}